// Copyright (c) 2022 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage, defineMessages, WrappedComponentProps, injectIntl } from "react-intl";

import { DataState } from "types";
import { IAction } from "actions";
import { IState } from "states/states";
import { AppState, UserState } from "states/schedulerstates";
import LoginErrorStatus from "./LoginErrorStatus";

interface IAppStateProps {
  appState: AppState;
  userState: UserState;
  loginDataState: DataState;
  parameterDataState: DataState;
}

const mapStateToProps = (state: IState) => {
  const props: IAppStateProps = {
    appState: state.scheduler.appState,
    userState: state.scheduler.userState,
    loginDataState: state.scheduler.loginDataState,
    parameterDataState: state.scheduler.parameterDataState,
  };
  return props;
};

interface IAppStateDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IAppStateDispatch = {};
  return dispatchProps;
};

class AppStateComponent extends React.Component<
  IAppStateProps & IAppStateDispatch & WrappedComponentProps
> {
  private getStateBox() {
    if (this.props.appState < AppState.LOGGED_IN || this.props.appState === AppState.READY) {
      if (this.props.loginDataState === DataState.SAVE_REQ) {
        if (
          this.props.userState === UserState.CHANGING_PASSWORD ||
          this.props.userState === UserState.FORGOT_PASSWORD
        ) {
          return (
            <div className="alert alert-warning mt-2">
              <FormattedMessage id="Changing password..." />
            </div>
          );
        } else {
          return (
            <div className="alert alert-warning mt-2">
              {this.props.userState === UserState.SINGING_UP ||
              this.props.userState === UserState.SINGING_UP_CONFIRM ? (
                <FormattedMessage id="Checking sign-up..." />
              ) : (
                <FormattedMessage id="Checking login..." />
              )}
            </div>
          );
        }
      } else if (this.props.loginDataState === DataState.SAVE_FAIL) {
        return <LoginErrorStatus />;
      }
      return <></>;
    } else if (this.props.appState < AppState.SITE_LIST_LOADED) {
      return (
        <div id="appstate">
          <div className="alert alert-warning mt-2">
            <FormattedMessage id="Loading site list..." />
          </div>
        </div>
      );
    } else if (
      this.props.appState >= AppState.SITE_SELECTED &&
      this.props.appState < AppState.PARAMETER_LOADED
    ) {
      if (this.props.parameterDataState === DataState.SAVE_FAIL) {
        return (
          <div className="alert alert-danger mt-2">
            <FormattedMessage id="Error loading parameters." />
          </div>
        );
      }
      return (
        <div className="alert alert-warning mt-2">
          <FormattedMessage id="Loading parameters..." />
        </div>
      );
    } else if (
      this.props.appState >= AppState.PARAMETER_LOADED &&
      this.props.appState < AppState.READY
    ) {
      return (
        <div className="alert alert-warning mt-2">
          <FormattedMessage id="Loading site data..." />
        </div>
      );
    }

    // no specific state info
    return <></>;
  }

  public render() {
    return <div id="appstate">{this.getStateBox()}</div>;
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AppStateComponent));
